import React from "react";
import "./style.css";
export default function ZoomIcon(props) {
    return (React.createElement("button", { className: "zoom-icon-container", onClick: () => {
            props.openZoom();
        }, title: "Powi\u0119ksz zdj\u0119cie" },
        React.createElement("img", { src: "../../assets/icons/zoom.svg", height: "20", alt: "Ikona powi\u0119kszenia" })));
}
